import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

    *, *::before, *::after {
        box-sizing: border-box;
    }

    * {
        margin: 0;
    }

    img, picture, video, canvas, svg {
        display: block;
        max-width: 100%;
    }


    input, button, textarea, select {
        font: inherit;
    }

    p, h1, h2, h3, h4, h5, h6 {
        overflow-wrap: break-word;
    }


    /*
     * Variables
     */
    :root {
        // colors
        /* --color-background: rgba(250, 250, 250, 1);
        --color-white: rgba(255, 255, 255, 1);
        --color-light-grey: rgba(243, 243, 244, 1);
        --color-navy: rgba(40, 43, 67, 1);
        --color-navy-20: rgba(40, 43, 67, 0.2);
        --color-navy-40: rgba(40, 43, 67, 0.4);
        --color-navy-60: rgba(40, 43, 67, 0.6);
        --color-navy-80: rgba(40, 43, 67, 0.8);
        --color-navy-10: rgba(40, 43, 67, 0.1);

        --color-red: rgba(252, 82, 23, 1);
        --color-red-10: rgba(252, 82, 23, 0.1);
        --color-red-20: rgba(252, 82, 23, 0.2);
        --color-red-80: rgba(252, 82, 23, 0.8);
        
        --color-blue: rgba(0, 8, 120, 1);
        --color-blue-10: rgba(0, 8, 120, .1);
        --color-blue-80: rgba(0, 8, 120, .8);
        --color-green: rgba(126, 215, 111, 1);
        --color-green-10: rgba(126, 215, 111, 0.1);
        --color-green-20: rgba(232, 246, 227, 1);

        --color-positive: var(--color-green);
        --color-negative: var(--color-red);
        --color-neutral: var(--color-navy);

        //fonts
        --font-primary-regular: 'ITC Avant Garde Gothic Std Book';
        --font-primary-medium: 'ITC Avant Garde Gothic Std Medium';
        --font-primary-bold: 'ITC Avant Garde Gothic Std Demi';
        --font-secondary-regular: 'Proxima Nova';
        --font-secondary-bold: 'Proxima Nova Bold';

        //font sizes
        --fontsize-small: 0.75rem;
        --fontsize-medium: 1rem;
        --fontsize-large: 1.25rem;
        --fontsize-xLarge: 1.5rem;
        --fontsize-xxLarge: 2rem;
        
        --lineheight-xSmall: 1.5;
        --lineheight-small: 1.5;
        --lineheight-medium: 1.5;
        --lineheight-large: 1.5;                

        --spacing-xSmall: 0.5rem;
        --spacing-small: 0.75rem;
        --spacing-medium: 1rem;
        --spacing-large: 1.25rem;
        --spacing-xLarge: 1.5rem;

        --gradient-etcho-scale-full: linear-gradient(
                0deg,
                #ed3d44 0%,
                #f6cb39 50%,
                #7ed76f 100%
            );
            
        --gradient-etcho-scale-neutral: linear-gradient(
                0deg,
                #f6cb39 0%, 
                #f6cb39 100%
            );            

        --gradient-etcho-scale-positive: linear-gradient(
                0deg,
                #f6cb39 0%, 
                 #7ed76f 100%
            );  
            
        --gradient-etcho-scale-negative: linear-gradient(
                0deg,
                #f6cb39 0%, 
                #ed3d44 100%
            );                                     */
    }


    // Animations (imagine we'll replace these with a dedicated library as we go)
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }


    html {
        box-sizing: border-box;
        background-color: ${({ theme }) => theme.colors.uLightOrange};
    }
    
    body {
        color: ${({ theme }) => theme.colors.uNavy};
        font-family:  ${({ theme }) => theme.fonts.secondary.regular};
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: normal; // font-weighing is applied by the family;
    }

    a {
        color: ${({ theme }) => theme.colors.uNavy};
    }
`;
